module.exports = __webpack_public_path__ + "img/museum-green.c87e18aa.svg";